import { getRandomColor } from 'module/ui/components/styles';
import { Tag } from '@rocketlane/ui';
import { FC } from 'react';
import styled from 'styled-components';
import { SharedPreviewConfiguration } from '../../../shared/preview-configuration';
import {
  SectionDivider,
  SectionPreview,
  SectionTitle,
} from '../../../shared/section-styles';
import { PeoplePageDerivedSectionSources } from '../../people-page-section-sources';
import { PeoplePageSourceDerivedSignalSectionComponentProps } from '../types';

const SignalsWrapper = styled.div`
  display: flex;
  gap: var(--spacing-02);
  margin-top: var(--spacing-02);
`;

interface Props extends PeoplePageSourceDerivedSignalSectionComponentProps {
  onWrapperClick: () => void;
}
export const PeoplePageSourceDerivedSignalSectionPromptPreview: FC<Props> = ({
  node,
  onWrapperClick,
}) => {
  const config = node.attrs.config;
  const configurationBarValue = {
    groupBy: config?.groupBy,
    generateAs: config?.generateAs,
  };

  return (
    <SectionPreview
      onClick={(event) => {
        event.stopPropagation();
        onWrapperClick();
      }}
    >
      <div>
        <SectionTitle>{node.attrs.title}</SectionTitle>
        <SignalsWrapper>
          {config.sourceSignalConfigurations.map((signal) => (
            <Tag
              key={signal.signalConfigurationId}
              color={getRandomColor(signal.signalConfigurationId) as any}
              variant="basic"
            >
              {signal.signalName}
            </Tag>
          ))}
        </SignalsWrapper>
      </div>
      <SharedPreviewConfiguration prompt={configurationBarValue} />
      <SectionDivider />
      <PeoplePageDerivedSectionSources sources={config.sourcePageTemplates} />
    </SectionPreview>
  );
};
